import * as React from 'react';
import {ClientBookmark} from "../../../../domain/model/client_bookmark";
import {Customer} from "../../../../domain/model/customer";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import ClientClientBookmarksMain from "./client_bookmarks_main";
import Progress from "../../../common/organism/progress";
import {TJobCareerWithCustomerID} from "../../../../domain/repository/job_career_repository";
import EmptyData from "../../../common/organism/empty_data";
import {ClientBookmarksEmpty} from "../../../../config/view_const/client_bookmarks";
import {TBreadcrumbItem} from "../../../type/common";
import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";

interface IProps {
    clientBookmarks: ClientBookmark[];
    customers: Customer[];
    jobCareersWithCustomerID: TJobCareerWithCustomerID[],
    isLoading: boolean;
}

const ClientClientBookmarksComponent: React.FC<IProps> = (props) => {

    const {clientBookmarks, customers, jobCareersWithCustomerID, isLoading} = props;

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        routeConfig.clientBookmarks
    ]

    const res: JSX.Element = (
        <React.Fragment>
            {isLoading && <Progress canAnimation={false}/>}
            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems} />

                { clientBookmarks.length === 0 &&
                <EmptyData
                    main={ClientBookmarksEmpty.clientBookmarksForClientMain}
                    description={ClientBookmarksEmpty.clientBookmarksForClientDescription}
                />
                }
                { clientBookmarks.length > 0 &&
                <ClientClientBookmarksMain
                    clientBookmarks={clientBookmarks}
                    customers={customers}
                    jobCareersWithCustomerID={jobCareersWithCustomerID}
                />
                }
            </PageWrapper>
        </React.Fragment>

    );

    return (res);

};

export default ClientClientBookmarksComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/client_bookmarks/client_bookmarks.tsx